/* Start-up: header controls, role switcher, first route. */
(function () {
  var K = window.KPS;
  K.$("#menuBtn").innerHTML = K.icon("menu");
  K.$("#searchBtn").innerHTML = K.icon("search");
  K.$("#acctBtn").innerHTML = K.icon("user");
  K.$("#cartIcon").innerHTML = K.icon("cart");
  K.$("#closeCart").innerHTML = K.icon("x");

  var sel = K.$("#roleSel");
  sel.innerHTML = Object.keys(K.ROLES).map(function (r) { return '<option value="' + r + '"' + (K.S.role === r ? " selected" : "") + ">" + K.ROLES[r] + "</option>"; }).join("");
  // Which customer account the signed-in club role belongs to (drives account pricing)
  K.syncAccountSel = function () {
    var a = K.$("#acctSel");
    a.innerHTML = K.S.accounts.map(function (x) { return '<option value="' + x.id + '"' + (K.S.activeAccount === x.id ? " selected" : "") + ">" + K.esc(x.name) + (x.status === "active" ? "" : " (paused)") + "</option>"; }).join("");
    K.$("#acctWrap").hidden = !K.can("clubPrice");
  };
  K.$("#acctSel").addEventListener("change", function (e) { K.S.activeAccount = e.target.value; K.save(); K.renderCart(); K.refresh(); K.toast("Prices now shown for " + e.target.selectedOptions[0].textContent); });
  sel.addEventListener("change", function () { K.S.role = sel.value; K.save(); K.syncAccountSel(); K.renderCart(); K.refresh(); K.toast("Now viewing as " + K.ROLES[sel.value]); });
  K.syncAccountSel();

  K.acts.navMenu = function (el) { var it = el.closest(".nav-item"), o = !it.classList.contains("open"); it.classList.toggle("open", o); el.setAttribute("aria-expanded", String(o)); };
  document.addEventListener("click", function (e) { if (!e.target.closest(".nav-item")) K.$$(".nav-item.open").forEach(function (n) { n.classList.remove("open"); K.$(".nav-caret", n).setAttribute("aria-expanded", "false"); }); });
  K.acts.menu = function () { var n = K.$("#mainNav"), o = !n.classList.contains("open"); n.classList.toggle("open", o); K.$("#menuBtn").setAttribute("aria-expanded", String(o)); };
  K.acts.resetDemo = function () { K.confirm("Reset the demo?", "<p>This clears everything you’ve changed in this browser and reloads the example data.</p>", "Reset").then(function (ok) { if (ok) { K.reset(); K.$("#roleSel").value = K.S.role; K.syncAccountSel(); K.renderCart(); } }); };
  function setBig(on) { document.documentElement.classList.toggle("big-text", on); K.$("#textBtn").setAttribute("aria-pressed", String(on)); try { localStorage.setItem("kps-big", on ? "1" : "0"); } catch (e) {} }
  K.acts.bigText = function () { setBig(!document.documentElement.classList.contains("big-text")); };
  try { if (localStorage.getItem("kps-big") === "1") setBig(true); } catch (e) {}

  // Storefront attribution: tell the checkout which storefront the shopper came from
  var place = K.acts.coPlace;
  K.acts.coPlace = function () {
    var before = K.S.orders.length, sub = require0();
    place.apply(null, arguments);
    var o = K.S.orders[K.S.orders.length - 1];
    if (K.S.orders.length > before && K.onOrderPlaced) { K.onOrderPlaced(o, { sub: sub }); K.save(); }
  };
  function require0() { return K.totals(K.S.cart).sub; }

  K.renderCart();
  K.go((location.hash || "#home").slice(1) || "home", { keepScroll: false });
})();
